export default "__VITE_ASSET__CFmbnC$9__"